import { vars } from "@imwebme/clay-token";
import { Clay } from "../utilities";
import { PROGRESS_BAR_DEFAULT_SIZE } from "./ProgressBar.constants";
import type { ProgressBarCoreProps } from "./ProgressBar.types";

export const ProgressBarCore = ({
  size = PROGRESS_BAR_DEFAULT_SIZE,
  value,
  variant,
}: ProgressBarCoreProps) => (
  <Clay
    flex={1}
    height={size === "medium" ? 8 : 4}
    overflow="hidden"
    borderRadius={vars.rounded.full}
    backgroundColor={vars.semantic.color.surfaceSlate}
  >
    <Clay
      height="100%"
      transition="width 0.3s ease-out"
      native={{
        style: {
          width: `${value}%`,
          backgroundColor: {
            primary: vars.semantic.color.borderSlate,
            success: vars.semantic.color.borderSuccess,
            critical: vars.semantic.color.borderCritical,
            highlight: vars.semantic.color.borderHighlight,
          }[variant],
        },
      }}
    />
  </Clay>
);
